import { useMutation } from "@tanstack/react-query";
import { useAxiosWithoutToken } from "../../../api/axios";

interface DataType {
  redirect_uri?: string | null;
  code?: string | null;
}

export const useSFLogin = (
  onSuccess?: void | ((data: any) => void),
  onError?: void | ((error: any) => void)
) => {
  const axios = useAxiosWithoutToken("salesforce");
  const urlKey = "/services/oauth2/token";
  return useMutation({
    mutationFn: async (data: DataType) => {
      if (data) {
        const response = await axios.post(urlKey, undefined, {
          params: {
            grant_type: "authorization_code",
            redirect_uri: data?.redirect_uri,
            client_id: process.env.REACT_APP_SALESFORCE_CLIENT_ID,
            client_secret: process.env.REACT_APP_SALESFORCE_CLIENT_SECRET,
            code: data?.code
          }
        });
        return response.data;
      } else {
        return;
      }
    },
    onSuccess: (data) => {
      // localStorage.setItem("user-detail", JSON.stringify(data.data));
      if (onSuccess) {
        onSuccess(data);
      }
    },
    onError: (err) => {
      console.error("error", err);
      if (onError) {
        onError(err);
      }
    }
  });
};
